import React from 'react';
import { Box, CategoryIcon, OverflowText, ServiceConfig, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

type Service = NonNullable<ServiceConfig['services']>[number];

interface Props {
  services: Service[];
}

const ServiceItem = styled(Box)`
  flex: 0 0 calc(33.33% - 8px);
  min-width: 150px;
`;

const ServicesList: React.FC<Props> = ({ services }) => {
  return (
    <Box
      background="module"
      pad="spacing16"
      round="container2Round"
      margin={{ top: 'spacing16', bottom: 'spacing16' }}
    >
      <Text size="large" color="textTitle" margin={{ bottom: 'spacing8' }}>
        Services
      </Text>
      <Box direction="row" gap={{ row: 'spacing8', column: 'spacing8' }} wrap>
        {services.map((service) => (
          <ServiceItem
            key={service.id}
            direction="row"
            align="center"
            gap="spacing4"
            pad={{ vertical: 'xs', horizontal: 's' }}
            background="canvas"
            round="fieldRound"
            border={{ color: 'border1', size: 'small' }}
          >
            <CategoryIcon isColorFullMode size="s" category={service.categoryType} />
            <OverflowText title={service.name} />
          </ServiceItem>
        ))}
      </Box>
    </Box>
  );
};

export default ServicesList;
